import { render, staticRenderFns } from "./FollowUpAppointment.vue?vue&type=template&id=9a081eda&scoped=true"
import script from "./FollowUpAppointment.vue?vue&type=script&lang=js"
export * from "./FollowUpAppointment.vue?vue&type=script&lang=js"
import style0 from "./FollowUpAppointment.vue?vue&type=style&index=0&id=9a081eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a081eda",
  null
  
)

export default component.exports